import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSubmissions(ctx, params) {
      return axios.get('/moderation/submissions', { params })
    },
    fetchPendingCount() {
      return axios.get('/moderation/submissions/pending-count')
    },
    fetchAuthors() {
      return axios.get('/moderation/authors')
    },
    approve(ctx, { id, comment }) {
      return axios.post(`/moderation/submissions/${id}/approve`, { comment })
    },
    reject(ctx, { id, comment }) {
      return axios.post(`/moderation/submissions/${id}/reject`, { comment })
    },
    fetchMy(ctx, params) {
      return axios.get('/moderation/my', { params })
    },
    fetchArtistPending(ctx, artistId) {
      return axios.get(`/artist/${artistId}/pending-submissions`)
    },
    createCoverLink(ctx, payload) {
      return axios.post('/moderation/cover-link', payload)
    },
    fetchUnpaid() {
      return axios.get('/moderation/payouts/unpaid')
    },
    fetchUnpaidForAuthor(ctx, authorId) {
      return axios.get(`/moderation/payouts/unpaid/${authorId}`)
    },
    pay(ctx, authorId) {
      return axios.post('/moderation/payouts', { author_id: authorId })
    },
    fetchPayouts(ctx, params) {
      return axios.get('/moderation/payouts', { params })
    },
  },
}
